var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { ItemsDefinition } from "@perxis-js/perxis-client/dist/items";
import { ReferencesDefinition } from "@perxis-js/perxis-client/dist/references";
import { createChannel, createClientFactory, Metadata } from "nice-grpc-web";
import { defaultOptionsMiddleware } from "./middleware/defaultOptionsMiddleware.js";
import { localeMiddleware } from "./middleware/localeMiddleware.js";
import { loggerMiddleware } from "./middleware/loggerMiddleware.js";
const _PerxisService = class _PerxisService {
  constructor(props) {
    __publicField(this, "_itemsClient");
    __publicField(this, "_referencesClient");
    __publicField(this, "channel");
    __publicField(this, "clientFactory");
    __publicField(this, "defaultCallOptions");
    const { apiRoot, apiKey, locale } = props;
    this.channel = createChannel(apiRoot);
    this.clientFactory = createClientFactory().use(
      localeMiddleware({
        localeId: locale
      })
    ).use(defaultOptionsMiddleware()).use(loggerMiddleware({}));
    this.defaultCallOptions = {
      "*": {
        metadata: Metadata({
          authorization: `API-Key ${apiKey}`
        })
      }
    };
  }
  /**
   * Возвращает экземпляр клиента для сервиса content.items.Items
   */
  get itemsClient() {
    if (!this._itemsClient) {
      this._itemsClient = this.clientFactory.create(ItemsDefinition, this.channel, this.defaultCallOptions);
    }
    return this._itemsClient;
  }
  /**
   * Возвращает экземпляр клиента для сервиса content.references.ReferencesType
   */
  get referencesClient() {
    if (!this._referencesClient) {
      this._referencesClient = this.clientFactory.create(ReferencesDefinition, this.channel, this.defaultCallOptions);
    }
    return this._referencesClient;
  }
  static getInstance(params) {
    if (!_PerxisService.instance) {
      _PerxisService.instance = new _PerxisService(params);
    }
    return _PerxisService.instance;
  }
};
__publicField(_PerxisService, "instance");
let PerxisService = _PerxisService;
export {
  PerxisService
};
